import { format } from 'date-fns';
import { DLZData } from '../../domain/DLZData';
import { DLZDTO } from '../dto/DLZDTO';

export class DLZMapper {
  static toDomain(dto: DLZDTO): DLZData {
    return new DLZData(
      dto.material_coverage_max_threshold ?? '-',
      dto.dlz_max_time_minutes,
      dto.modified_at === null
        ? '-'
        : format(new Date(dto.modified_at), 'yyy-MM-dd:HH:mm:ss'),
      dto.modified_by
    );
  }

  static toDomainList(dtos: DLZDTO[]): DLZData[] {
    return dtos.map(this.toDomain);
  }
}
